import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import EmbeddedSignup from './EmbeddedSignup';

interface FacebookSignupModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onSuccess?: () => void;
}

export default function FacebookSignupModal({
    open,
    onOpenChange,
    onSuccess
}: FacebookSignupModalProps) {
    const handleSuccess = () => {
        onSuccess?.();
        onOpenChange(false);
    };

    const handleCancel = () => {
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                className="sm:max-w-md bg-white"
                hideCloseButton
                onInteractOutside={(e) => {
                    e.preventDefault();
                }}
                onEscapeKeyDown={(e) => {
                    e.preventDefault();
                }}
            >
                <DialogHeader>
                    <DialogTitle>Conectar WhatsApp Business</DialogTitle>
                </DialogHeader>
                <EmbeddedSignup
                    onSuccess={handleSuccess}
                    onCancel={handleCancel}
                    configId="1690470751765654"
                />
                <DialogFooter>
                    <Button variant="outline" onClick={handleCancel} className="w-full">
                        Cancelar
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
